import { Injectable } from '@angular/core';
import { PopupRef, PopupService, INIT_POSITION_POPUP } from '@local/ui-infra';
import { take, takeUntil } from 'rxjs';
import {
  SpecificResourcePopupComponent,
  SpecificResourcePopupModel,
} from '../components/specific-resource-popup/specific-resource-popup.component';
import {
  SlackActionButtonsPopupComponent,
  SlackActionButtonsPopupModel,
} from '../components/slack-action-buttons-popup/slack-action-buttons-popup.component';

@Injectable()
export class AssistantPopupService {
  specificResourcePopupPopupRef: PopupRef<SpecificResourcePopupComponent, SpecificResourcePopupModel> = null;

  constructor(public popupService: PopupService) {}

  openSpecificResourcePopup(model: SpecificResourcePopupModel, savePopup: Function) {
    if (this.specificResourcePopupPopupRef) {
      this.specificResourcePopupPopupRef.destroy();
    }
    this.specificResourcePopupPopupRef = this.popupService.open<SpecificResourcePopupComponent, SpecificResourcePopupModel>(
      'center',
      SpecificResourcePopupComponent,
      model,
      { closeOnClickOut: true, backdropStyle: 'blur-2', panelClass: 'specific-resource-popup' }
    );

    this.specificResourcePopupPopupRef.compInstance.savePopup
      .pipe(takeUntil(this.specificResourcePopupPopupRef.destroy$))
      .subscribe((value) => {
        savePopup(value);
      });
    this.specificResourcePopupPopupRef.destroy$.pipe(take(1)).subscribe(() => {
      this.specificResourcePopupPopupRef = null;
    });
    return this.specificResourcePopupPopupRef;
  }

  openSlackActionButtonsPopup(model: SlackActionButtonsPopupModel) {
    let popupRef = this.popupService.open<SlackActionButtonsPopupComponent, SlackActionButtonsPopupModel>(
      'center',
      SlackActionButtonsPopupComponent,
      model,
      { closeOnClickOut: true, backdropStyle: 'blur-2' }
    );

    popupRef.destroy$.pipe(take(1)).subscribe(() => {
      popupRef = null;
    });
  }
}
